import * as React from 'react';
import { SVGProps } from 'react';

const SvgDna = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m15.841 35.195 2.667-2.671a10.686 10.686 0 0 0 2.771-10.355l-1.423-5.177a13.078 13.078 0 0 1 3.364-12.66L25.075 2.5"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m4.115 23.481 2.67-2.67a10.687 10.687 0 0 1 10.35-2.781l5.18 1.418a13.078 13.078 0 0 0 12.656-3.377l1.83-1.857"
    />
    <path
      fill={props.fill}
      d="M16.516 36.87 3.125 23.48l3.336-3.336L16.497 30.18l.02 6.691Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m23.53 4.47 11 11m-14-8 11 11M19.5 11.5 28 20m-7.937 10.462L8.906 19.621M21.5 27l-9.086-8.96"
    />
  </svg>
);

export default SvgDna;
